/*** 
 * 描述：系统公共的footer部分
 */ 
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sw-footer',
  templateUrl: './sw-footer.component.html',
  styleUrls: ['./sw-footer.component.css']
})
export class SwFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}